export default {
    methods: {
        initComplete() {
            this.$emit('initSuccess')
        }
    },
}
